import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { ChatErrorContent } from "@/shared/domain/chat/ChatRecord";

import styles from "./AssistantErrorContent.module.css";

interface AssistantErrorContentProps {
  error: ChatErrorContent;
}

/**
 * Component for rendering error content in chat messages.
 * Displays an error icon and user-friendly error message.
 */
export const AssistantErrorContent = ({
  error,
}: AssistantErrorContentProps) => {
  return (
    <div className={styles.indentedContainer}>
      <div className={styles.messageContainer}>
        <ErrorOutlineIcon className={styles.errorIcon} />
        <RobotoTypography className={styles.text}>
          {error.error_message}
        </RobotoTypography>
      </div>
    </div>
  );
};
